export default __webpack_public_path__ + "static/media/v_10.bf9d72f1.jpg";